/* Talas Akademija: theme interactions */
(function () {
  'use strict';

  // -- Video embeds: swap poster with iframe/video on click ----
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-video-trigger]');
    if (!trigger) return;
    var wrapper = trigger.closest('[data-video-embed]');
    if (!wrapper) return;
    var src = wrapper.getAttribute('data-src');
    var provider = wrapper.getAttribute('data-provider');
    var title = wrapper.getAttribute('data-title') || 'Video';
    var player = wrapper.querySelector('.video-embed__player');
    if (!src || !player) return;

    e.preventDefault();

    // Escape quotes/HTML in title for safe attribute insertion
    var safeTitle = title.replace(/"/g, '&quot;').replace(/</g, '&lt;');

    if (provider === 'file') {
      player.innerHTML =
        '<video src="' + src + '" controls autoplay playsinline title="' + safeTitle +
        '" style="width:100%;height:100%"></video>';
    } else {
      player.innerHTML =
        '<iframe src="' + src + '" title="' + safeTitle +
        '" loading="lazy" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen frameborder="0"></iframe>';
    }
    player.hidden = false;
    trigger.style.display = 'none';
  });

  // -- Courses carousel: continuous conveyor-belt drift.
  //    The belt moves via native scrollLeft (not transforms), so manual
  //    scrolling always composes: touch/trackpad work natively, desktop gets
  //    drag-to-scroll + arrows. A scrubbable progress bar mirrors the REAL
  //    scroll position (auto or manual). Infinite loop via duplicated track,
  //    wrapped silently at the pass boundary in both directions.
  //    Drift pauses on hover/interaction/video/offscreen/hidden tab, and is
  //    disabled entirely under prefers-reduced-motion.
  function initCarousel(el) {
    if (el.dataset.carouselInit) return;
    el.dataset.carouselInit = 'true';
    var track = el.querySelector('.courses-carousel__track');
    if (!track) return;

    var blockCount = parseInt(el.dataset.blockCount, 10) || 0;
    var speed = parseFloat(el.dataset.speed);
    if (isNaN(speed) || speed < 0) speed = 35; // px per second
    var resumeMs = parseFloat(el.dataset.resumeMs);
    if (isNaN(resumeMs)) resumeMs = 4000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var section = el.closest('.courses') || el.parentElement;
    var nav = section && section.querySelector('[data-courses-nav]');
    var fill = nav && nav.querySelector('[data-progress-fill]');
    var scrubber = nav && nav.querySelector('[data-progress-scrubber]');
    var counterEl = nav && nav.querySelector('[data-counter-current]');
    var prevBtn = nav && nav.querySelector('[data-arrow-prev]');
    var nextBtn = nav && nav.querySelector('[data-arrow-next]');

    function cards() { return track.querySelectorAll('.course'); }
    function cardStep() {
      var c = cards();
      if (c.length < 2) return 0;
      return c[1].offsetLeft - c[0].offsetLeft;
    }
    function passWidth() {
      var c = cards();
      if (c.length > blockCount && c[blockCount]) {
        return c[blockCount].offsetLeft - c[0].offsetLeft;
      }
      return track.scrollWidth / 2;
    }

    var hovering = false;
    var dragging = false;
    var inView = true;
    var pausedUntil = 0;
    var vpos = null;          // float mirror of scrollLeft while drifting
    var lastWritten = -1;     // last scrollLeft we wrote (detects external moves)
    var anim = null;          // in-flight arrow-step animation {from, to, start, dur}
    var gestureActive = false; // finger currently down on the carousel
    var lastScrollT = -1;     // last scroll event of ANY origin
    var lastInternalT = -1;   // last scrollLeft write WE made (drift/anim/wrap)

    function interacted() {
      pausedUntil = performance.now() + resumeMs;
      vpos = null;
      anim = null;
    }

    el.addEventListener('mouseenter', function () { hovering = true; });
    el.addEventListener('mouseleave', function () { hovering = false; });
    el.addEventListener('wheel', interacted, { passive: true });
    el.addEventListener('touchstart', function () {
      gestureActive = true;
      interacted();
    }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (evt) {
      el.addEventListener(evt, function () { gestureActive = false; }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0 }).observe(el);
    }

    // Silent wrap at pass boundaries. Content in both passes is identical,
    // so the jump is invisible. Wrapping near 0 backwards enables endless
    // reverse scrolling too. The two wrap zones use hysteresis (target
    // positions sit strictly inside (EDGE, pw + EDGE)) so they can never
    // trigger each other in a ping-pong loop.
    //
    // `internal` = this frame's motion came from us (drift/arrow anim), so a
    // wrap composes invisibly. For USER motion we must wait until the finger
    // is up AND momentum has settled: on iOS, writing scrollLeft mid-gesture
    // re-anchors the touch and visibly flickers.
    var EDGE = 2; // px
    function wrap(internal) {
      var pw = passWidth();
      if (pw <= 0) return;
      if (!internal) {
        var idle = performance.now() - lastScrollT > 150;
        if (gestureActive || dragging || !idle) return;
      }
      if (el.scrollLeft >= pw + EDGE) {
        el.scrollLeft -= pw;
        if (vpos !== null) vpos -= pw;
        if (anim) { anim.from -= pw; anim.to -= pw; }
        lastInternalT = performance.now();
      } else if (el.scrollLeft < EDGE && pw + EDGE < el.scrollWidth - el.clientWidth) {
        el.scrollLeft += pw;
        if (vpos !== null) vpos += pw;
        if (anim) { anim.from += pw; anim.to += pw; }
        lastInternalT = performance.now();
      }
    }

    var lastT = null;
    function frame(t) {
      if (lastT === null) lastT = t;
      var dt = Math.min((t - lastT) / 1000, 0.1);
      lastT = t;
      var wrote = false;
      if (anim) {
        // Arrow-step animation runs through THIS loop (not native smooth
        // scroll) so a wrap can shift it mid-flight instead of cancelling it.
        var p = Math.min((t - anim.start) / anim.dur, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        el.scrollLeft = anim.from + (anim.to - anim.from) * ease;
        lastWritten = el.scrollLeft;
        lastInternalT = performance.now();
        wrote = true;
        if (p >= 1) anim = null;
      } else {
        // No document.hidden gate needed: browsers pause rAF in hidden tabs,
        // and the dt clamp above absorbs the catch-up frame on return.
        var canDrift =
          !reduce && speed > 0 && inView && !hovering && !dragging &&
          !gestureActive &&
          performance.now() > pausedUntil &&
          !el.querySelector('iframe, video');
        if (canDrift) {
          // If something else moved the scroll (momentum, anchor), re-anchor.
          if (vpos === null || Math.abs(el.scrollLeft - lastWritten) > 1.5) {
            vpos = el.scrollLeft;
          }
          vpos += speed * dt;
          el.scrollLeft = vpos;
          lastWritten = el.scrollLeft;
          lastInternalT = performance.now();
          wrote = true;
        } else {
          vpos = null;
        }
      }
      wrap(wrote);
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    // Progress bar + counter mirror the actual scroll position.
    function syncProgress() {
      if (!nav) return;
      var pw = passWidth();
      if (pw <= 0) return;
      var frac = (((el.scrollLeft % pw) + pw) % pw) / pw;
      if (fill) fill.style.width = (frac * 100).toFixed(2) + '%';
      var step = cardStep();
      if (counterEl && step > 0 && blockCount > 0) {
        var idx = ((Math.round(el.scrollLeft / step) % blockCount) + blockCount) % blockCount;
        counterEl.textContent = String(idx + 1);
      }
      if (scrubber) scrubber.setAttribute('aria-valuenow', String(Math.round(frac * 100)));
    }
    var sf = null;
    el.addEventListener('scroll', function () {
      var now = performance.now();
      lastScrollT = now;
      // Externally-driven motion (touch drag, iOS momentum, trackpad): keep
      // postponing the drift resume so it can never fight a live fling.
      if (now - lastInternalT > 80) {
        var until = now + resumeMs;
        if (until > pausedUntil) pausedUntil = until;
        vpos = null;
      }
      if (sf) return;
      sf = requestAnimationFrame(function () { sf = null; syncProgress(); });
    }, { passive: true });
    syncProgress();

    // Desktop drag-to-scroll (mouse only; touch already scrolls natively).
    var dragStartX = 0, dragStartScroll = 0, draggedFar = false;
    el.addEventListener('pointerdown', function (e) {
      interacted();
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      draggedFar = false;
      dragStartX = e.clientX;
      dragStartScroll = el.scrollLeft;
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      el.classList.add('is-dragging');
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 5) draggedFar = true;
      el.scrollLeft = dragStartScroll - dx;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('is-dragging');
      interacted();
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    // A drag must not end as an accidental link/video click.
    el.addEventListener('click', function (e) {
      if (draggedFar) {
        e.preventDefault();
        e.stopPropagation();
        draggedFar = false;
      }
    }, true);

    // Arrows: one card per click, eased via the frame loop. Rapid clicks
    // chain from the in-flight target so each click counts.
    function stepBy(dir) {
      var s = cardStep();
      if (s <= 0) return;
      var base = anim ? anim.to : el.scrollLeft;
      interacted(); // clears anim, sets pause
      anim = {
        from: el.scrollLeft,
        to: base + dir * s,
        start: performance.now(),
        dur: 350
      };
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { stepBy(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepBy(1); });

    // Scrubber: click/drag the bar to jump anywhere; arrow keys step cards.
    if (scrubber) {
      var scrubbing = false;
      function scrubTo(clientX) {
        var rect = scrubber.getBoundingClientRect();
        if (rect.width <= 0) return;
        var frac = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 0.999);
        el.scrollLeft = frac * passWidth();
        interacted();
      }
      scrubber.addEventListener('pointerdown', function (e) {
        scrubbing = true;
        scrubTo(e.clientX);
        try { scrubber.setPointerCapture(e.pointerId); } catch (_) {}
      });
      scrubber.addEventListener('pointermove', function (e) {
        if (scrubbing) scrubTo(e.clientX);
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        scrubber.addEventListener(evt, function () { scrubbing = false; });
      });
      scrubber.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); stepBy(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); stepBy(1); }
      });
    }
  }

  function initAllCarousels() {
    document.querySelectorAll('[data-courses-carousel]').forEach(initCarousel);
  }
  initAllCarousels();
  document.addEventListener('shopify:section:load', initAllCarousels);

  // -- Loom thumbnail loader v2. Loom's CDN thumbnail URL contains an
  //    unpredictable hash, so it must come from their public oEmbed endpoint.
  //    Hardened against the failure modes that made gifs flaky:
  //      * burst rate-limiting -> lazy fetch (only near viewport) + max 3
  //        concurrent requests + 2 retries with backoff + 6s timeout
  //      * repeat visits -> localStorage cache (7 days) skips the network
  //    Priority: the animated Loom thumb always loads OVER a manual poster
  //    (fade-in once fully loaded); the poster remains the fallback whenever
  //    Loom fails, times out, or the visitor is offline.
  var LOOM_TTL = 7 * 24 * 3600 * 1000;
  var LOOM_MAX_CONCURRENT = 3;
  var loomQueue = [];
  var loomActive = 0;

  function loomCacheGet(key) {
    try {
      var obj = JSON.parse(localStorage.getItem(key));
      if (obj && obj.url && Date.now() - obj.ts < LOOM_TTL) return obj.url;
    } catch (_) {}
    return null;
  }
  function loomCacheSet(key, url) {
    try { localStorage.setItem(key, JSON.stringify({ url: url, ts: Date.now() })); } catch (_) {}
  }

  function insertLoomThumb(btn, url, title) {
    if (btn.querySelector('.video-embed__loom-thumb')) return;
    var img = document.createElement('img');
    img.className = 'video-embed__loom-thumb';
    img.alt = title || btn.getAttribute('aria-label') || 'Video';
    img.decoding = 'async';
    img.onload = function () {
      // Only reveal once fully loaded, so the manual poster never flashes away
      img.classList.add('is-loaded');
      btn.classList.remove('video-embed__poster--blank');
    };
    img.onerror = function () { img.remove(); }; // fallback: poster stays
    img.src = url;
    btn.insertBefore(img, btn.firstChild);
  }

  function loomPump() {
    while (loomActive < LOOM_MAX_CONCURRENT && loomQueue.length) {
      runLoomJob(loomQueue.shift(), 0);
    }
  }

  function runLoomJob(btn, attempt) {
    loomActive++;
    var endpoint = btn.getAttribute('data-loom-oembed');
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 6000);
    function release() { loomActive--; loomPump(); }
    fetch(endpoint, { credentials: 'omit', signal: controller ? controller.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (data) {
        clearTimeout(timer);
        if (!data || !data.thumbnail_url) throw new Error('no thumbnail');
        loomCacheSet('loomthumb:' + endpoint, data.thumbnail_url);
        insertLoomThumb(btn, data.thumbnail_url, data.title);
        release();
      })
      .catch(function () {
        clearTimeout(timer);
        release();
        if (attempt < 2) {
          // transient failure (rate limit / network blip): retry with backoff
          setTimeout(function () {
            loomQueue.push(btn);
            // re-run with attempt+1 by wrapping: shift would lose the count,
            // so run directly when a slot is free
            if (loomActive < LOOM_MAX_CONCURRENT) {
              loomQueue.pop();
              runLoomJob(btn, attempt + 1);
            }
          }, 1200 * (attempt + 1));
        }
        // attempt exhausted: manual poster / placeholder stays — by design
      });
  }

  function loadLoomThumbnails() {
    var btns = document.querySelectorAll('[data-loom-oembed]');
    if (!btns.length) return;

    function enqueue(btn) {
      if (btn.dataset.loomQueued) return;
      btn.dataset.loomQueued = 'true';
      var cached = loomCacheGet('loomthumb:' + btn.getAttribute('data-loom-oembed'));
      if (cached) { insertLoomThumb(btn, cached); return; }
      loomQueue.push(btn);
      loomPump();
    }

    // Fetch only when the video is within ~600px of the viewport: avoids the
    // page-load burst that made Loom rate-limit half the requests.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          enqueue(e.target);
        });
      }, { rootMargin: '600px 0px' });
      btns.forEach(function (b) { io.observe(b); });
    } else {
      btns.forEach(enqueue);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadLoomThumbnails);
  } else {
    loadLoomThumbnails();
  }

  // -- Live Skool stats. If the merchant has set a worker URL in theme settings,
  //    fetch live counts from the proxy and update every [data-skool-stat] element.
  //    Mirrors snippets/pluralize-sr.liquid so Serbian word forms re-derive
  //    correctly when the count crosses a paucal/plural boundary.
  function pluralizeSr(n, singular, paucal, plural) {
    n = Math.abs(Math.floor(n));
    var lastTwo = n % 100;
    var lastOne = n % 10;
    if (lastTwo >= 11 && lastTwo <= 14) return plural;
    if (lastOne === 1) return singular;
    if (lastOne >= 2 && lastOne <= 4) return paucal;
    return plural;
  }

  function applySkoolStats(data) {
    if (!data) return;
    document.querySelectorAll('[data-skool-stat]').forEach(function (el) {
      var key = el.getAttribute('data-skool-stat');
      var n = data[key];
      if (typeof n !== 'number') return;
      var singular = el.getAttribute('data-skool-singular');
      var paucal = el.getAttribute('data-skool-paucal');
      var plural = el.getAttribute('data-skool-plural');
      if (singular && paucal && plural) {
        el.textContent = n + ' ' + pluralizeSr(n, singular, paucal, plural);
      } else {
        // Preserve any non-number prefix/suffix in the label-style stats:
        // we only update if the existing content looks numeric. Otherwise
        // we'd risk overwriting localized strings with raw numbers.
        el.textContent = String(n);
      }
    });
  }

  function loadSkoolStats() {
    var cfg = window.__SKOOL;
    if (!cfg || !cfg.workerUrl) return;
    if (!document.querySelector('[data-skool-stat]')) return;

    // Skip if we fetched recently this session (cheap throttle to avoid
    // re-fetching on every SPA-style navigation).
    try {
      var key = 'skool-stats:' + cfg.community;
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var cached = JSON.parse(raw);
        var ttl = (cfg.refreshSeconds || 300) * 1000;
        if (cached && cached.ts && Date.now() - cached.ts < ttl && cached.data) {
          applySkoolStats(cached.data);
          return;
        }
      }
    } catch (_) {}

    var url = cfg.workerUrl.replace(/\/+$/, '') +
      '/?community=' + encodeURIComponent(cfg.community || '');

    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || data.error) return;
        applySkoolStats(data);
        try {
          sessionStorage.setItem(
            'skool-stats:' + cfg.community,
            JSON.stringify({ ts: Date.now(), data: data })
          );
        } catch (_) {}
      })
      .catch(function () { /* keep static fallback */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadSkoolStats);
  } else {
    loadSkoolStats();
  }

  // -- Sticky CTA: keep body padding-bottom in sync with the actual rendered
  //    button height. Theme.css sets a sensible static default so the layout
  //    is correct on first paint; this refines it for user-configured sizes.
  function syncStickyPadding() {
    var sticky = document.querySelector('.about-cta-sticky');
    if (!sticky) {
      document.body.style.paddingBottom = '';
      return;
    }
    if (window.matchMedia('(max-width: 899px)').matches) {
      document.body.style.paddingBottom = sticky.offsetHeight + 8 + 'px';
    } else {
      document.body.style.paddingBottom = '';
    }
  }
  window.addEventListener('load', syncStickyPadding);
  window.addEventListener('resize', syncStickyPadding);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncStickyPadding);
  }

  // -- Scroll animations: reveal-on-scroll + number count-up.
  //    Progressive enhancement: hidden states only apply once <html> gets the
  //    `js-anim` class, which THIS script adds — so if JS never runs, nothing
  //    is ever hidden. Respects prefers-reduced-motion.
  var REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Elements that get a reveal animation without needing data-reveal in Liquid.
  // NOTE: .course is deliberately NOT here — carousel cards live inside a
  // moving scroller; reveal fade-ins there read as pop-in, and the wrap
  // jumps would churn the observer.
  var AUTO_REVEAL_SELECTORS = [
    '.about-stats__item',
    '.testimonial',
    '.segment',
    '.hiw__step',
    '.mentor',
    '.faq__item'
  ];

  function initScrollAnimations() {
    if (REDUCE_MOTION || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('js-anim');

    // Auto-tag common cards; siblings get a stagger index for cascading delays.
    AUTO_REVEAL_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        if (!el.hasAttribute('data-reveal')) {
          el.setAttribute('data-reveal', '');
          el.style.setProperty('--reveal-delay', Math.min(i % 6, 5) * 70 + 'ms');
        }
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          startCountups(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      observer.observe(el);
    });

    // Count-up targets that aren't inside a [data-reveal] element
    document.querySelectorAll('[data-countup]').forEach(function (el) {
      if (el.closest('[data-reveal]')) return;
      observer.observe(el);
    });
  }

  // Count-up: animates the first integer found in the element's text while
  // preserving surrounding text (e.g. "1.024 članova" → counts the number,
  // keeps the pluralized word). Skool live updates may overwrite later; fine.
  function animateCount(el) {
    if (el.getAttribute('data-countup-done')) return;
    var text = el.textContent;
    var m = text.match(/^([^\d]*)([\d][\d.,\s]*)(.*)$/s);
    if (!m) return;
    var numStr = m[2].trim();
    var target = parseInt(numStr.replace(/[.,\s]/g, ''), 10);
    if (isNaN(target) || target <= 0) return;
    // Keep the original thousands separator style
    var sep = numStr.indexOf('.') > -1 ? '.' : numStr.indexOf(',') > -1 ? ',' : '';
    el.setAttribute('data-countup-done', 'true');

    var duration = 1200;
    var start = null;
    function fmt(n) {
      var s = String(n);
      if (sep && n >= 1000) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return s;
    }
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = m[1] + fmt(Math.round(target * eased)) + m[3];
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function startCountups(root) {
    if (REDUCE_MOTION) return;
    if (root.hasAttribute && root.hasAttribute('data-countup')) animateCount(root);
    root.querySelectorAll('[data-countup]').forEach(animateCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }
  // Re-init when the merchant adds/reorders sections in the theme editor
  document.addEventListener('shopify:section:load', initScrollAnimations);

  // -- Birthday sale banner + confetti.
  //    Day math runs here (not in Liquid) because rendered HTML is CDN-cached:
  //    "Akcija traje još X dana" / "još 1 dan" / "do 23:59h" on the final day,
  //    then the banner removes itself entirely once the end date passes.
  function initBirthdayBanner() {
    var banner = document.querySelector('[data-birthday-banner]');
    if (!banner) return;

    // Dismissed this session?
    try {
      if (sessionStorage.getItem('bb-dismissed')) { banner.remove(); return; }
    } catch (_) {}

    var endStr = (banner.getAttribute('data-end-date') || '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(endStr)) {
      var p = endStr.split('-');
      var endDayStart = new Date(+p[0], +p[1] - 1, +p[2]);
      var endOfDay = new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59, 999);
      var now = new Date();
      if (now > endOfDay) { banner.remove(); return; } // sale over: vanish
      var daysEl = banner.querySelector('[data-birthday-days]');
      if (daysEl) {
        var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var days = Math.round((endDayStart - todayStart) / 86400000);
        daysEl.textContent = days <= 0
          ? 'Akcija traje još do 23:59h'
          : 'Akcija traje još ' + days + ' ' + pluralizeSr(days, 'dan', 'dana', 'dana');
        daysEl.hidden = false;
      }
    }

    // Sticky offset: header (and friends) slide down by the banner's real height.
    document.body.classList.add('bb-active');
    function syncBannerHeight() {
      document.documentElement.style.setProperty('--bb-h', banner.offsetHeight + 'px');
    }
    syncBannerHeight();
    window.addEventListener('resize', syncBannerHeight);

    var closeBtn = banner.querySelector('[data-birthday-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        banner.remove();
        document.body.classList.remove('bb-active');
        try { sessionStorage.setItem('bb-dismissed', '1'); } catch (_) {}
      });
    }

    // Confetti: one short burst on EVERY page load while the sale runs
    // (owner's choice), never for reduced motion. Performance is a non-issue:
    // inline canvas, zero network, runs ~3s after load and removes itself —
    // it can't affect LCP/CLS because it starts after the page is interactive
    // and draws on a non-interactive overlay.
    if (banner.getAttribute('data-confetti') === 'true' && !REDUCE_MOTION) {
      launchConfetti();
    }
  }

  function launchConfetti() {
    var canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var colors = ['#258afe', '#25c6fe', '#fe80de', '#ffd446', '#22c55e', '#f97316'];
    var W = window.innerWidth;
    var count = W < 700 ? 70 : 110; // research guidance: <100-ish for mobile 60fps
    var parts = [];
    for (var i = 0; i < count; i++) {
      parts.push({
        x: Math.random() * W,
        y: -30 - Math.random() * window.innerHeight * 0.25,
        w: 6 + Math.random() * 5,
        h: 9 + Math.random() * 6,
        vx: -1.2 + Math.random() * 2.4,
        vy: 2.2 + Math.random() * 3,
        rot: Math.random() * Math.PI,
        vr: -0.12 + Math.random() * 0.24,
        color: colors[i % colors.length]
      });
    }
    var DURATION = 3; // seconds, fade in the last second
    var start = null;
    function tick(t) {
      if (start === null) start = t;
      var elapsed = (t - start) / 1000;
      ctx.clearRect(0, 0, W, window.innerHeight);
      ctx.globalAlpha = Math.max(0, Math.min(1, (DURATION - elapsed)));
      for (var i = 0; i < parts.length; i++) {
        var pt = parts[i];
        pt.x += pt.vx;
        pt.y += pt.vy;
        pt.vy += 0.05;
        pt.rot += pt.vr;
        ctx.save();
        ctx.translate(pt.x, pt.y);
        ctx.rotate(pt.rot);
        ctx.fillStyle = pt.color;
        ctx.fillRect(-pt.w / 2, -pt.h / 2, pt.w, pt.h);
        ctx.restore();
      }
      if (elapsed < DURATION) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBirthdayBanner);
  } else {
    initBirthdayBanner();
  }

  // -- Wins wall: infinite scroll over the private community's "Pobede"
  //    posts, served as sanitized JSON by the Cloudflare worker (/wins).
  //    Fully lazy: first fetch happens only when the visitor nears the
  //    section; further batches load as they scroll. If the worker is not
  //    configured/reachable, the whole section hides itself.
  function relDateSr(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days <= 0) return 'danas';
    if (days === 1) return 'juče';
    if (days < 30) return 'pre ' + days + ' ' + pluralizeSr(days, 'dan', 'dana', 'dana');
    var months = Math.floor(days / 30);
    if (months < 12) return 'pre ' + months + ' ' + pluralizeSr(months, 'mesec', 'meseca', 'meseci');
    var years = Math.floor(days / 365);
    return 'pre ' + years + ' ' + pluralizeSr(years, 'godinu', 'godine', 'godina');
  }

  function initWinsWall() {
    var section = document.querySelector('[data-wins-wall]');
    if (!section) return;
    var cfg = window.__SKOOL;
    if (!cfg || !cfg.workerUrl) { section.style.display = 'none'; return; }

    var grid = section.querySelector('[data-wins-grid]');
    var statusEl = section.querySelector('[data-wins-status]');
    var sentinel = section.querySelector('[data-wins-sentinel]');
    var batch = parseInt(section.dataset.pageSize, 10) || 12;
    var base = cfg.workerUrl.replace(/\/+$/, '');

    var buffer = [];
    var nextPage = 1;
    var total = Infinity;
    var fetched = 0;
    var rendered = 0;
    var loading = false;
    var failed = false;

    function winCard(p) {
      var art = document.createElement('article');
      art.className = 'win';

      var head = document.createElement('header');
      head.className = 'win__head';
      if (p.avatar) {
        var av = document.createElement('img');
        av.className = 'win__avatar';
        av.src = p.avatar;
        av.alt = p.author || '';
        av.loading = 'lazy';
        av.onerror = function () { av.remove(); };
        head.appendChild(av);
      }
      var who = document.createElement('div');
      who.className = 'win__who';
      var author = document.createElement('span');
      author.className = 'win__author';
      author.textContent = p.author || 'Član zajednice';
      who.appendChild(author);
      var date = relDateSr(p.createdAt);
      if (date) {
        var time = document.createElement('span');
        time.className = 'win__date';
        time.textContent = date;
        who.appendChild(time);
      }
      head.appendChild(who);
      art.appendChild(head);

      if (p.title) {
        var h = document.createElement('h3');
        h.className = 'win__title';
        h.textContent = p.title;
        art.appendChild(h);
      }
      if (p.content) {
        var body = document.createElement('p');
        body.className = 'win__content';
        body.textContent = p.content;
        art.appendChild(body);
      }
      if (p.image) {
        var img = document.createElement('img');
        img.className = 'win__image';
        img.src = p.image;
        img.alt = p.title || '';
        img.loading = 'lazy';
        img.onerror = function () { img.remove(); };
        art.appendChild(img);
      }
      var meta = document.createElement('footer');
      meta.className = 'win__meta';
      meta.textContent = '👍 ' + (p.upvotes || 0) + '  ·  💬 ' + (p.comments || 0);
      art.appendChild(meta);
      return art;
    }

    function fetchPage() {
      if (loading || failed || fetched >= total) return Promise.resolve();
      loading = true;
      statusEl.hidden = false;
      return fetch(base + '/wins?page=' + nextPage, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
        .then(function (data) {
          if (!data || !Array.isArray(data.posts)) throw new Error('shape');
          total = data.total || total;
          buffer = buffer.concat(data.posts);
          fetched += data.posts.length;
          if (data.posts.length === 0) total = fetched;
          nextPage++;
        })
        .catch(function () { failed = true; })
        .then(function () { loading = false; statusEl.hidden = true; });
    }

    // Masonry columns: every card is appended to the currently SHORTEST
    // column, so chronological order reads top-down across the wall instead
    // of CSS-columns' fill-left-first (which put a month-old post beside
    // yesterday's). Rebuilt in order when the breakpoint changes.
    var allCards = [];
    var cols = [];
    var twoColMq = window.matchMedia('(min-width: 700px)');

    function shortestCol() {
      var best = cols[0];
      for (var i = 1; i < cols.length; i++) {
        if (cols[i].offsetHeight < best.offsetHeight) best = cols[i];
      }
      return best;
    }

    function placeCard(card) {
      shortestCol().appendChild(card);
    }

    function buildCols() {
      grid.textContent = '';
      cols = [];
      var n = twoColMq.matches ? 2 : 1;
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'wins__col';
        grid.appendChild(col);
        cols.push(col);
      }
      // re-place existing cards in original (newest-first) order
      for (var j = 0; j < allCards.length; j++) placeCard(allCards[j]);
    }

    buildCols();
    twoColMq.addEventListener
      ? twoColMq.addEventListener('change', buildCols)
      : twoColMq.addListener(buildCols);

    function renderBatch() {
      var want = batch;
      (function run() {
        while (want > 0 && buffer.length) {
          var card = winCard(buffer.shift());
          allCards.push(card);
          placeCard(card);
          rendered++;
          want--;
        }
        if (rendered > 0) grid.hidden = false;
        if (want > 0 && fetched < total && !failed) {
          fetchPage().then(run);
        } else if (failed && rendered === 0) {
          section.style.display = 'none'; // worker down + nothing to show
        }
      })();
    }

    // Bootstrap lazily when the section approaches the viewport
    var started = false;
    function start() {
      if (started) return;
      started = true;
      renderBatch();
      if ('IntersectionObserver' in window && sentinel) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && !loading) renderBatch();
        }, { rootMargin: '500px 0px' }).observe(sentinel);
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        start();
      }, { rootMargin: '800px 0px' });
      io.observe(section);
    } else {
      start();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWinsWall);
  } else {
    initWinsWall();
  }

  // -- CorvusPay checkout links: with "Plaćanje preko CorvusPay-a" on, join
  //    buttons carry data-checkout and the bare checkout URL (snippets/join-href).
  //    Pages are CDN-cached, so this visit's query string (fbclid, gclid, ttclid,
  //    utm_* …) is added here, for the app's ad attribution.
  //    shortcut: only the current page's query is carried (see fable.js).
  function checkoutLinks() {
    var q = location.search.slice(1);
    if (!q) return;
    document.querySelectorAll('a[data-checkout]').forEach(function (a) {
      if (a.__qs) return;
      a.__qs = true;
      var u = new URL(a.href);
      u.search += (u.search ? '&' : '') + q;
      a.href = u.href;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkoutLinks);
  } else {
    checkoutLinks();
  }
  document.addEventListener('shopify:section:load', checkoutLinks);

  // -- The app's price (CorvusPay switch), for a deal-price snippet on a page
  //    of this layer: the same as fable.js cena(), and the same once-per-visit
  //    answer (sessionStorage). Before it answers, or if it fails, the theme's
  //    „Cena" stays; the editor keeps showing the setting.
  var cenaData = null;
  function cena() {
    if (!cenaData) return;
    var rsd = Number(cenaData.rsd).toLocaleString('sr-RS') + ' RSD';
    var lok = cenaData.lokalna;
    document.querySelectorAll('[data-cena]').forEach(function (el) { el.textContent = lok ? lok.tekst : rsd; });
    document.querySelectorAll('[data-cena-rsd]').forEach(function (el) { el.textContent = lok ? '(' + rsd + ')' : ''; el.hidden = !lok; });
    document.querySelectorAll('[data-cena-napomena]').forEach(function (el) { el.textContent = lok ? cenaData.napomena || '' : ''; el.hidden = !lok; });
  }
  function cenaOnce() {
    var a = document.querySelector('a[data-checkout]');
    if ((window.Shopify && window.Shopify.designMode) || !a || !document.querySelector('[data-cena]')) return;
    var use = function (d) {
      if (!d || typeof d.rsd !== 'number') return false;
      cenaData = d;
      cena();
      return true;
    };
    try { if (use(JSON.parse(sessionStorage.getItem('talas-cena')))) return; } catch (e) {}
    fetch(new URL('/api/javno/cena', a.href).href)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!use(d)) return;
        try { sessionStorage.setItem('talas-cena', JSON.stringify(d)); } catch (e) {}
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cenaOnce);
  } else {
    cenaOnce();
  }
  document.addEventListener('shopify:section:load', cena);

  // -- Conversion tracking: label every click toward the Skool community as a
  //    GA4 "join_click" event with the on-page location, so the funnel shows
  //    WHICH button converts (sticky CTA vs hero vs final CTA vs segment card).
  //    With the CorvusPay switch on, the same buttons carry data-checkout.
  //    No-op when GA4 isn't configured.
  document.addEventListener('click', function (e) {
    if (typeof window.gtag !== 'function') return;
    var a = e.target.closest('a[href*="skool.com/talasakademija"], a[data-checkout]');
    if (!a) return;
    var location = 'other';
    if (a.closest('.about-cta-sticky')) location = 'sticky_cta';
    else if (a.closest('.about-cta')) location = 'main_cta';
    else if (a.closest('.final-cta')) location = 'final_cta';
    else if (a.closest('.about-sidebar, [class*="sidebar"]')) location = 'sidebar';
    else if (a.closest('.segment')) location = 'segment_card';
    else if (a.closest('.article__cta')) location = 'article_cta';
    else if (a.closest('.wins')) location = 'wins_wall';
    else if (a.closest('.loyalty')) location = 'loyalty';
    else if (a.closest('.birthday-banner')) location = 'birthday_banner';
    gtag('event', 'join_click', { cta_location: location, sale: window.__SALE === true });
  }, { passive: true });
})();
